(() => {
  document.documentElement.setAttribute('data-deferred-media-js', 'true');

  const imageSelector = 'img[data-deferred-section-media][data-src]';
  const imageLoadedAttribute = 'data-deferred-section-media-loaded';
  const autoplayVideoSelector = '[data-deferred-autoplay-video]:not([data-deferred-autoplay-loaded])';
  const autoplayVideoLoadedAttribute = 'data-deferred-autoplay-loaded';
  const autoplayVideoReadyAttribute = 'data-deferred-autoplay-ready';

  const loadImage = (image) => {
    if (!image || image.hasAttribute(imageLoadedAttribute)) return;

    const srcset = image.getAttribute('data-srcset');
    const src = image.getAttribute('data-src');

    if (srcset) image.setAttribute('srcset', srcset);
    if (src) image.setAttribute('src', src);

    image.setAttribute(imageLoadedAttribute, 'true');
    image.removeAttribute('data-src');
    image.removeAttribute('data-srcset');
  };

  const loadAutoplayVideo = (container) => {
    if (!container || container.hasAttribute(autoplayVideoLoadedAttribute)) return;

    const template = container.querySelector('template');
    const templateContent = template?.content?.firstElementChild;
    if (!templateContent) return;

    const media = templateContent.cloneNode(true);
    const markReady = () => container.setAttribute(autoplayVideoReadyAttribute, 'true');

    container.setAttribute(autoplayVideoLoadedAttribute, 'true');
    container.appendChild(media);

    if (media.nodeName !== 'VIDEO') {
      markReady();
      return;
    }

    media.muted = true;
    media.playsInline = true;
    media.setAttribute('muted', '');
    media.setAttribute('playsinline', '');
    media.addEventListener('loadeddata', markReady, { once: true });
    media.addEventListener('canplay', markReady, { once: true });
    media.addEventListener('playing', markReady, { once: true });

    const playPromise = media.play?.();
    if (playPromise?.catch) playPromise.catch(() => {});
  };

  const observeImages = (root = document) => {
    const images = root.querySelectorAll(imageSelector);
    const autoplayVideos = root.querySelectorAll(autoplayVideoSelector);
    if (!images.length && !autoplayVideos.length) return;

    if (window.Shopify?.designMode || !('IntersectionObserver' in window)) {
      images.forEach(loadImage);
      autoplayVideos.forEach(loadAutoplayVideo);
      return;
    }

    const imageObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          loadImage(entry.target);
          imageObserver.unobserve(entry.target);
        });
      },
      { rootMargin: '300px 0px' },
    );

    const autoplayVideoObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          loadAutoplayVideo(entry.target);
          autoplayVideoObserver.unobserve(entry.target);
        });
      },
      { rootMargin: '300px 0px' },
    );

    images.forEach((image) => imageObserver.observe(image));
    autoplayVideos.forEach((container) => autoplayVideoObserver.observe(container));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => observeImages(), { once: true });
  } else {
    observeImages();
  }

  document.addEventListener('shopify:section:load', (event) => observeImages(event.target));
  document.addEventListener('luredolls:deferred-collection:loaded', (event) => {
    if (event.detail?.root) observeImages(event.detail.root);
  });
})();
